import {
  Component,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { MatRowDef, MatTableModule } from "@angular/material/table";
import { MatDialogModule, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CommonModule, NgIf } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatOptionModule } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import {
  NgSelectModule,
} from "@ng-select/ng-select";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from "app/utils/method";
import { ICreateRequirement } from "./interfaces/create-requirement.interface";
import RequirementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/requirements/requirements.entity";
import { RequirementService } from "./requirement.service";
import { IUpdateRequirement } from "./interfaces/update-requirement.interface";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { NoFiltersAvailableComponent } from "app/common/components/no-filters-available/no-filters-available.component";
import { FilterComponent } from "app/common/components/filter/filter.component";


@Component({
  selector: "app-requirement",
  templateUrl: "./requirement.component.html",
  styleUrls: ["./requirement.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgSelectModule,
    MatTabsModule,
    StatusFiltersComponent,
    HoverMenuDirective,
    NoFiltersAvailableComponent,
    FilterComponent
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
})
export class RequirementComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name", "status", "actions"];
  currentCreateRequirement: ICreateRequirement =
    this.initializeCreateRequirement();
  currentUpdateRequirement: RequirementAttributes | undefined;

  dataSource: RequirementAttributes[] = [];

  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;


  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: number [] = [];
  
  constructor(
    private readonly requirementService: RequirementService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private initializeCreateRequirement(): ICreateRequirement {
    return { name: "", description: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";

    this.requirementService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
      this.selectedStatuses
    )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof RequirementAttributes {
    const validSortFields: (keyof RequirementAttributes)[] = [
      "name",
      "statusId",
    ];
    return validSortFields.includes(
      this.sort.active as keyof RequirementAttributes
    )
      ? (this.sort.active as keyof RequirementAttributes)
      : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: RequirementAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.currentCreateRequirement = this.initializeCreateRequirement();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createRequirement());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(condition: RequirementAttributes): void {
    this.currentUpdateRequirement = { ...condition };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateRequirement(condition._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createRequirement(): void {
    this.requirementService.create(this.currentCreateRequirement).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateRequirement(id: string): void {
    if (this.currentUpdateRequirement) {
      const updatedRequirement: IUpdateRequirement = {
        ...this.currentUpdateRequirement,
      };

      this.requirementService.update(id, updatedRequirement).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, condition: RequirementAttributes): void {
    const originalStatusId = condition.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedRequirement = { ...condition, statusId: updatedStatusId };

    this.requirementService
      .update(condition._id.toString(), updatedRequirement)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          condition.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(condition: RequirementAttributes): void {
    this.dialog
      .open(this.deleteDialog, {
        data: condition,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.delete(condition._id.toString()));
  }

  delete(id: string): void {
    this.requirementService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  clearFilters(): void {
    this.searchQuery = "";
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
